import _ from "lodash";
import { toast } from "react-toastify";
import countries from "../data/countries.json";

const defaultImage = "//static.carfromjapan.com/public/images/car-default.jpg";

const mapValues = {
  AUTOMANUAL: "AMT",
  AUTOMATIC: "AT",
  CVT: "CVT",
  MANUAL: "MT",
  UNSPECIFIED: "NA"
};

export const isMobile = () => {
  return window.innerWidth <= 992;
};

export const getImageCDN = (image, width, height) => {
  if (!image) return defaultImage;
  if (!image.filename) return defaultImage;
  if (image.rejected) return defaultImage;
  if (width === undefined && height === undefined) return "//" + image.cdnUri + "/" + image.filename;
  return "//" + image.cdnUri + "/" + image.filename + `_${width}_${height}`;
};

export const flattenObject = ob => {
  let toReturn = {};

  for (let i in ob) {
    if (!ob.hasOwnProperty(i)) continue;

    if (typeof ob[i] == "object" && ob[i] !== null) {
      let flatObject = flattenObject(ob[i]);
      for (let x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue;

        toReturn[i + "." + x] = flatObject[x];
      }
    } else {
      toReturn[i] = ob[i];
    }
  }
  return toReturn;
};
export const unflattenObject = data => {
  if (Object(data) !== data || Array.isArray(data)) return data;
  let regex = /\.?([^.\[\]]+)|\[(\d+)\]/g; //eslint-disable-line
  let resultholder = {};
  for (var p in data) {
    var cur = resultholder,
      prop = "",
      m;
    while ((m = regex.exec(p))) {
      cur = cur[prop] || (cur[prop] = m[2] ? [] : {});
      prop = m[2] || m[1];
    }
    cur[prop] = data[p];
  }
  return resultholder[""] || resultholder;
};
export const valuesType = value => {
  if (value === "true" || value === true) return true;
  if (value === "false" || value === false) return false;
  if (!isNaN(Number(value))) return Number(value);
  return value;
};

export const formatNumber = number => {
  if (number === 0) return 0;
  if (!number) return;
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const parseNumber = (value, name) => {
  if (!value) return "";
  if (_.isString(value)) return Number(value.replace(/,/g, ""));
  return Number(value);
};

export const keyToText = (key, literal = " ") =>
  (key || "")
    .replace(/_/g, "-")
    .split("-")
    .map(segment => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join(literal);

export const bytesToSize = bytes => {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) return "0 Byte";
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
};

export const toPrettyValue = (value, uppercase, keepOriginal) => {
  let formattedValue = mapValues[value];
  if (formattedValue) return formattedValue;
  formattedValue = value || "";
  formattedValue = formattedValue.replace(/_/g, "");
  if (uppercase) {
    formattedValue = _.toUpper(formattedValue);
  } else if (!keepOriginal) formattedValue = _.capitalize(formattedValue);
  return formattedValue;
};

export const capitalizeAllFirstLetter = (string, keepCapitalize) => {
  return string.replace(/\w\S*/g, txt => {
    return txt.charAt(0).toUpperCase() + (keepCapitalize ? txt.substr(1) : txt.substr(1).toLowerCase());
  });
};

export const getTranslation = ({ locale }) => {
  const ads = require(`../translation/${locale}/ads.json`);
  const boxtext = require(`../translation/${locale}/boxtext.json`);
  const cars = require(`../translation/${locale}/cars.json`);
  const common = require(`../translation/${locale}/common.json`);
  const company = require(`../translation/${locale}/company.json`);
  const coupon = require(`../translation/${locale}/coupon.json`);
  const csvs = require(`../translation/${locale}/csvs.json`);
  const dashboard = require(`../translation/${locale}/dashboard.json`);
  const freight = require(`../translation/${locale}/freight.json`);
  const kpi = require(`../translation/${locale}/kpi.json`);
  const local_page_management = require(`../translation/${locale}/local-page-management.json`);
  const local_page = require(`../translation/${locale}/local-page.json`);
  const macro = require(`../translation/${locale}/macro.json`);
  const macros = require(`../translation/${locale}/macros.json`);
  const models = require(`../translation/${locale}/models.json`);
  const modelspecs = require(`../translation/${locale}/modelspecs.json`);
  const orders = require(`../translation/${locale}/orders.json`);
  const tags = require(`../translation/${locale}/tags.json`);
  const testimonials = require(`../translation/${locale}/testimonials.json`);
  const transformations = require(`../translation/${locale}/transformations.json`);
  return {
    ...ads,
    ...boxtext,
    ...cars,
    ...common,
    ...company,
    ...coupon,
    ...csvs,
    ...dashboard,
    ...freight,
    ...kpi,
    ...local_page_management,
    ...local_page,
    ...macro,
    ...macros,
    ...models,
    ...modelspecs,
    ...orders,
    ...tags,
    ...testimonials,
    ...transformations
  };
};

export const _formatJsonString = param => {
  let result = param;
  try {
    result = JSON.parse(param);
  } catch (err) {}
  return result;
};

export const setCookie = (name, value, days) => {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};
export const getCookie = (name, decode) => {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length === 2) {
    const result = parts
      .pop()
      .split(";")
      .shift();
    if (decode) return decodeURIComponent(result);
    return result;
  }
};

export const thenExcute = (promise, next) => promise && promise.then(next).catch(e => toast.error(e.message));

export const copyToClipboard = str => {
  const el = document.createElement("textarea"); // Create a <textarea> element
  el.value = str; // Set its value to the string that you want copied
  el.setAttribute("readonly", ""); // Make it readonly to be tamper-proof
  el.style.position = "absolute";
  el.style.left = "-9999px"; // Move outside the screen to make it invisible
  document.body.appendChild(el); // Append the <textarea> element to the HTML document
  const selected =
    document.getSelection().rangeCount > 0 // Check if there is any content selected previously
      ? document.getSelection().getRangeAt(0) // Store selection if found
      : false; // Mark as false to know no selection existed before
  el.select(); // Select the <textarea> content
  document.execCommand("copy"); // Copy - only works as a result of a user action (e.g. click events)
  document.body.removeChild(el); // Remove the <textarea> element
  if (selected) {
    // If a selection existed before copying
    document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
    document.getSelection().addRange(selected); // Restore the original selection
  }
};

export const countryOptions = Object.keys(countries).map(code => ({ value: countries[code].name, label: countries[code].name }));

export const arrayMove = (arr, index1, index2) => {
  [arr[index1], arr[index2]] = [arr[index2], arr[index1]];
};

const formatContent = (text = "") => text.replace(/\s\s+/g, " ");
export const getContentKeyBoxtext = ({ year, make, model, local, landingTag }) => (landingTag ? `tags-${landingTag}` : formatContent(`${(local && `${local}-`) || ""}${year || ""}-${make || ""}-${model || ""}`));
export const generateSEOParams = key => {
  if (!key) return {};
  const yearRegex = /\d{4}/;
  const localRegex = /kenya|jamaica/;
  const result = {};
  if (key.includes("tags-")) {
    result.landingTag = key.split("tags-")[1];
  }
  if (localRegex.test(key)) {
    const local = key.match(localRegex);
    result.local = local[0];
  }
  if (yearRegex.test(key)) {
    const year = key.match(yearRegex);
    result.year = year[0];
  }
  const localYearKey = formatContent(`${(result.local && `${result.local}-`) || ""}${result.year || ""}`);
  const makeModel = key
    .replace(localYearKey, "")
    .split("-")
    .filter(o => !!o);
  const makeModelKey = makeModel
    .map(o =>
      o
        .split(" ")
        .join("-")
        .toLowerCase()
    )
    .join("-");
  const makeModelName = makeModel.join(" ");
  if (makeModelKey) result.makeModelKey = makeModelKey;
  if (makeModelName) result.makeModelName = makeModelName;
  return result;
};

export const generateSEOUrl = ({ makeModelKey, year, local, landingTag }) => {
  if (landingTag) return `/tags/${landingTag}`;
  if (makeModelKey && year && local) return `/${local}/cheap-used-${makeModelKey}-for-sale-year${year}`;
  if (makeModelKey && local) return `/${local}/cheap-used-${makeModelKey}-for-sale`;
  if (makeModelKey && year) return `/cheap-used-${makeModelKey}-for-sale-year${year}`;
  if (makeModelKey) return `/cheap-used-${makeModelKey}-for-sale`;
  if (year) return `/cheap-used-cars-for-sale-year${year}`;
  return `/cheap-used-cars-for-sale`;
};

export const getMetaFind = function({ makeModelYear, bodyType, price, minPrice, maxPrice, transmission, fuelType, driveType, steering, minDisplacement, maxDisplacement, local }) {
  const tokensTitle = ["Used"];
  const tokensDesc = ["Check Out the best deals of used"];
  var meta = {
    title: "Explore best selection of used cars with high quality",
    description: "Find affordable used cars for sale in good condition and at attractive prices. See detailed features, send inquiry, ask questions, compare deals and buy now."
  };
  let commonPush = function(str) {
    tokensTitle.push(str);
    tokensDesc.push(str);
  };
  let uniqueValuePush = function(titleStr, descString) {
    tokensTitle.push(titleStr);
    tokensDesc.push(descString);
  };
  if (makeModelYear) {
    commonPush(makeModelYear);
  } else {
    uniqueValuePush("cars", "vehicles");
  }

  tokensTitle.push("for sale");
  if (bodyType) {
    if (makeModelYear) {
      tokensDesc.push(bodyType);
    } else {
      tokensDesc[_.indexOf(tokensDesc, "vehicles")] = bodyType;
    }
  }

  if (minPrice && maxPrice) {
    if (minPrice === maxPrice) {
      commonPush(`at $${formatNumber(price)}`);
    } else {
      commonPush(`price $${formatNumber(minPrice)} to $${formatNumber(maxPrice)}`);
    }
  } else if (minPrice) {
    commonPush(`more than $${formatNumber(minPrice)}`);
  } else if (maxPrice) {
    commonPush(`under $${formatNumber(maxPrice)}`);
  }

  if (minPrice || maxPrice) {
    tokensDesc.push("with low mileage big discounts");
  } else {
    tokensDesc.push("at good prices with low mileage big discounts");
  }

  if (bodyType) {
    if (makeModelYear) {
      tokensTitle.push(bodyType);
    } else {
      tokensTitle[_.indexOf(tokensTitle, "cars")] = bodyType;
    }
  }

  if (transmission) {
    commonPush(transmission.toLowerCase());
  }

  if (fuelType) {
    uniqueValuePush(`using ${fuelType.toLowerCase()}`, `using ${fuelType.toLowerCase()}`);
  }

  if (driveType) {
    commonPush(driveType);
  }

  if (steering) {
    uniqueValuePush(`${steering.toLowerCase()} Steering`, `${steering.toLowerCase()} steering`);
  }

  if (minDisplacement && maxDisplacement) {
    if (minDisplacement === maxDisplacement) {
      commonPush(`${formatNumber(minDisplacement)}cc`);
    } else {
      commonPush(`${formatNumber(minDisplacement)} cc to ${formatNumber(maxDisplacement)} cc`);
    }
  } else if (minDisplacement) {
    commonPush(`more than ${formatNumber(minDisplacement)} cc`);
  } else if (maxDisplacement) {
    commonPush(`less than ${formatNumber(maxDisplacement)} cc`);
  }
  if (local) {
    commonPush(`in ${_.capitalize(local)}`);
  }

  tokensTitle.push(" | CAR FROM JAPAN");
  tokensDesc.push(". Great Quality. Fast Shipment. 24/7 Support. Simple Procedure.");

  _.extend(meta, {
    title: capitalizeAllFirstLetter(tokensTitle.join(" "), true),
    description: tokensDesc.join(" ").replace(" .", ".")
  });
  return meta;
};

export const generateParamsFromURL = str => {
  if (!str) return {};
  let price;
  const url = str.split("?")[0] + "-";
  const params = {};
  const makeModelYear = url.match(/(?:cheap-used-).+?(?=-for-sale)/);
  const bodyType = url.match(/(?:-body-).+?(?=-)/);
  const maxPrice = url.match(/(?:-under-usd).+?(?=-)/);
  const minPrice = url.match(/(?:-over-usd).+?(?=-)/);
  if (!minPrice && !maxPrice) {
    price = url.match(/(?:-usd).+?(?=-)/);
  }
  const year = url.match(/(?:-year).+?(?=-)/);
  const transmission = url.match(/(?:-transmission-).+?(?=-)/);
  const minDisplacement = url.match(/(?:-over-cc).+?(?=-)/);
  const maxDisplacement = url.match(/(?:-under-cc).+?(?=-)/);
  const fuelType = url.match(/(?:-fuel-).+?(?=-)/);
  const driveType = url.match(/(?:-drive-type-).+?(?=-)/);
  const steering = url.match(/(?:-steering-).+?(?=-)/);
  const local = url.split("/");
  const tag = url.match(/(?:tags).+?(?=-)/);

  params.makeModelYear = makeModelYear && capitalizeAllFirstLetter(makeModelYear[0].split("-").join(" "));
  params.bodyType = bodyType && bodyType[0] && bodyType[0].replace("_", " / ");
  params.maxPrice = maxPrice && maxPrice[0];
  params.minPrice = minPrice && minPrice[0];
  params.price = price && price[0];
  params.year = year && year[0];
  params.transmission = transmission && transmission[0];
  params.minDisplacement = minDisplacement && minDisplacement[0];
  params.maxDisplacement = maxDisplacement && maxDisplacement[0];
  params.fuelType = fuelType && fuelType[0];
  params.driveType = driveType && driveType[0];
  params.steering = steering && steering[0];
  params.local = local.length === 3 && local[1];
  params.tag = tag && tag[0];

  const otherParams = Object.fromEntries(new URLSearchParams(url.split("?")[1]));
  return { ...params, ...otherParams };
};

export const swap = function(json) {
  var ret = {};
  for (var key in json) {
    ret[json[key]] = key;
  }
  return ret;
};

export const wasCarExpired = car => {
  if (!car || !car.expiredAt) return false;
  const now = new Date();
  return new Date(car.expiredAt) < now;
};
